export default function MissingFeaturesDirective(
	usersService,
	ngShowDirective
) {
	'ngInject';

	var ngShow = ngShowDirective[0];
	return {
		transclude: ngShow.transclude,
		priority: ngShow.priority - 1,
		terminal: ngShow.terminal,
		restrict: ngShow.restrict,
		scope: false,
		link: function(scope, elt, attrs) {
			var features = scope.$eval(attrs.missingFeatures);

			var user = usersService.currentUser();
			var userFeatures = user ? user.features : [];

			var validComponent = function() {
				for (var i = 0; i < features.length; i++) {
					var s = features[i];

					var hasState = false;

					for (var j = 0; j < userFeatures.length; j++) {
						if (userFeatures[j].path == s) {
							hasState = true;
							break;
						}
					}
					if (!hasState) {
						return false;
					}
				}
				return true;
			};

			var initialNgIf = attrs.ngShow,
				ifEvaluator;
			// if it exists, evaluates ngShow && ifAuthenticated
			if (initialNgIf) {
				ifEvaluator = function() {
					return scope.$eval(initialNgIf) && !validComponent();
				};
			} else {
				// if there's no ng-if, process normally
				ifEvaluator = function() {
					return !validComponent();
				};
			}
			attrs.ngShow = ifEvaluator;
			ngShow.link.apply(ngShow, arguments);
		}
	};
}
